import { render } from "./FetcherView.vue?vue&type=template&id=153fef5c"
import script from "./FetcherView.vue?vue&type=script&lang=js"
export * from "./FetcherView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__